import { render, staticRenderFns } from "./OcorrenciasGerais.vue?vue&type=template&id=67fbd362"
import script from "./OcorrenciasGerais.vue?vue&type=script&lang=js"
export * from "./OcorrenciasGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports